import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Auth routes
 * ----------------------------
 */

export const loginRoute = (data, callback) => {
    getAxiosInstanceApi().post("/auth/login", data)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const logoutUser = (callback) => {
    getAxiosInstanceApi().post("/auth/logout")
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getMe = (callback) => {
    cachiosInstance.get("/auth/me")
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response);
        });
};
